<template>
  <main v-if="!isLoadingView" class="l-main p-config-management">
    <TitleMain icon="config">
      <span class="title">ユーザー情報・各種設定</span>
    </TitleMain>
    <div class="l-container">
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Breadcrumb />
      </div>
      <div class="l-block l-block--center">
        <TabConfig active="management" />
        <div class="l-block__content">
          <div class="l-block__header l-mb-5">
            <TitleSub level="h3">
              SEARCH WRITEにアクセスできるユーザーをサイトごとに管理できます。
            </TitleSub>
            <p class="c-text--bold l-mt-1">
              ※この画面は「所有者」「アカウント管理ユーザー」にのみ表示されています。
            </p>
          </div>
          <ManagementUser class="l-mb-10" />
          <ManagementAccess />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import ButtonToProjects from '@/components/ButtonToProjects';
import ManagementAccess from '@/components/config/ManagementAccess';
import ManagementUser from '@/components/config/ManagementUser';
import TabConfig from '@/components/config/TabConfig';
import TitleMain from '@/components/TitleMain';
import TitleSub from '@/components/TitleSub';

export default {
  components: {
    Breadcrumb,
    ButtonToProjects,
    ManagementAccess,
    ManagementUser,
    TabConfig,
    TitleMain,
    TitleSub
  },
  computed: {
    organization() {
      return this.$store.getters['view/organization'];
    },
    isAuthority() {
      return this.organization.isAuthority;
    },
    isLoadingView() {
      return this.$store.state.view.isLoading;
    }
  },
  created() {
    this.getMe();
  },
  methods: {
    getMe() {
      // 組織権限が確認できるまでローダーを表示する
      this.$store.dispatch('view/setLoading', true);

      this.$store.dispatch('user/getMe').finally(() => {
        if (this.isAuthority) {
          this.$store.dispatch('view/setLoading', false);
        } else {
          this.$router.push({ name: 'projects' });
        }
      });
    }
  }
};
</script>
